import type { MemberStats } from "@/types";

/**
 * memberStats — Single source of truth para contagens de membros.
 *
 * Hardcoded values; manualmente atualizado semanalmente. NUNCA referenciar
 * "91.319" / "1.430" / "92.749" em qualquer outro arquivo da app
 * (Anti-Pattern 1, ARCHITECTURE.md §10). Sempre consumir via:
 *   import { memberStats, formatMemberCount } from "@/data/stats";
 */
const WHATSAPP_COUNT = 91319;
const TELEGRAM_COUNT = 1430;

export const memberStats = {
  whatsapp: WHATSAPP_COUNT,
  telegram: TELEGRAM_COUNT,
  // SETUP-07 D-51: COMPUTADO, NUNCA hardcoded — previne drift
  totalAggregate: WHATSAPP_COUNT + TELEGRAM_COUNT,
  lastUpdated: "2026-08-23",
} as const satisfies MemberStats;

/**
 * Formata número para pt-BR (separador de milhar = ponto).
 * SETUP-06 D-52: usa Intl.NumberFormat — zero-bundle, native, robusto.
 *
 * Casos:
 *   formatMemberCount(91319)   === "91.319"
 *   formatMemberCount(1000)    === "1.000"
 *   formatMemberCount(999)     === "999"
 *   formatMemberCount(1234567) === "1.234.567"
 *   formatMemberCount(92319)   === "92.319"
 */
export function formatMemberCount(n: number): string {
  return new Intl.NumberFormat("pt-BR").format(n);
}
